<template>
    <section id="countdown">
        <div class="timer">
            <div class="unit">
                <div class="value">{{ pad(days) }}</div>
                <div class="label">Days</div>
            </div>
            <div class="separator">:</div>
            <div class="unit">
                <div class="value">{{ pad(hours) }}</div>
                <div class="label">Hours</div>
            </div>
            <div class="separator">:</div>
            <div class="unit">
                <div class="value">{{ pad(minutes) }}</div>
                <div class="label">Minutes</div>
            </div>
            <div class="separator">:</div>
            <div class="unit">
                <div class="value">{{ pad(seconds) }}</div>
                <div class="label">Seconds</div>
            </div>
        </div>
    </section>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue';

export default {
    name: "CountdownTimer",

    setup() {
        // Target: 3pm on 17 January 2026 in GMT+2, represented as 13:00:00 UTC
        const targetDate = new Date(Date.UTC(2026, 0, 17, 13, 0, 0))

        const days = ref(0)
        const hours = ref(0)
        const minutes = ref(0)
        const seconds = ref(0)
        let intervalId = null

        const updateCountdown = () => {
            const now = new Date()
            const diffMs = targetDate.getTime() - now.getTime()

            if (diffMs <= 0) {
                days.value = 0
                hours.value = 0
                minutes.value = 0
                seconds.value = 0
                if (intervalId) clearInterval(intervalId)
                return;
            }

            const totalSeconds = Math.floor(diffMs / 1000)
            days.value = Math.floor(totalSeconds / (60 * 60 * 24))
            hours.value = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60))
            minutes.value = Math.floor((totalSeconds % (60 * 60)) / 60)
            seconds.value = totalSeconds % 60
        };

        onMounted(() => {
            updateCountdown()
            intervalId = setInterval(updateCountdown, 1000)
        });

        onUnmounted(() => {
            if (intervalId) clearInterval(intervalId)
        });

        const pad = (num) => String(num).padStart(2, '0')

        return { days, hours, minutes, seconds, pad }
    },
}
</script>

<style scoped>
section {
    padding-top: 0;
}

#countdown .subheading {
    margin-bottom: 0.75rem;
}

.timer {
    display: inline-flex;
    align-items: center;
    gap: clamp(0.25rem, 2.5vw, 1rem);
}

.unit {
    min-width: clamp(48px, 12vw, 70px);
}

.value {
    font-size: clamp(1.25rem, 6vw, 2rem);
    font-weight: 600;
}

.label {
    font-size: clamp(0.6rem, 2.5vw, 0.75rem);
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.separator {
    font-size: clamp(1.25rem, 6vw, 2rem);
    line-height: 1;
}

/* Additional guardrails for very small devices */
@media (max-width: 360px) {
    .unit { min-width: 44px; }
}
</style>